import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const Container = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 5rem;
  @media (max-width: ${breakpoints.medium}) {
    padding: 1.6rem 0 3.2rem 0;
    margin: 0 auto;
    width: 90%;
  }
`;

export const ExercisesMenu = styled.ul`
  display: grid;
  max-width: 136.3rem;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4.8rem;

  @media (max-width: ${breakpoints.medium}) {
    grid-template-columns: 1fr;
    row-gap: 2.4rem;
  }
`;

export const ExercisesMenuItem = styled.li`
  width: 100%;
  max-width: 439px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 6px #00000021;
  transition: 0.3s;

  &:hover {
    background: ${({ theme }) => theme.colors.yellow};
    cursor: pointer;
    transition: 0.3s;
  }
`;

export const ExercisesMenuLink = styled.button`
  display: flex;
  background: none;
  width: 100%;
  padding: 2.4rem 3.2rem;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
  font-size: 1.8rem;
`;
